<!--
 * @Author: wuzuojie 15727841808@163.com
 * @Date: 2023-07-31 17:25:45
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-11 14:29:48
 * @FilePath: /chaoyongtuan/src/views/teamManage/roleManage/roleManage.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="roleManage main-content-padding">
		<div class="roleManage-head p-16"> 角色管理 </div>
		<div class="flex-row flex-just-start pt-16 rolePart">
			<div class="roleAside" v-loading="roleLoading">
				<p class="yx-color-text-primary font-h6-regular mt-16 ml-16">系统角色</p>
				<p
					v-for="item in roleList"
					:key="item.id"
					class="roleName cursor-pointer flex-row-align-center flex-just-start font-h4-regular"
					:class="{ active: item.id === activeIndex }"
					@click="activeTab(item)"
				>
					<i class="el-icon-user mr-10 ml-16"></i>
					<span>{{ `${item.name}` | formatEmpty | textFormat(10) }}</span>
					<span>({{ item.userRoleCount }})</span>
				</p>
				<!-- 需要加个父元素，否则没有权限的时候会把角色都删除 -->
				<span v-auth="['system:role:create']">
					<el-button type="text" class="ml-24 mt-6" @click="addRole">
						<i class="el-icon-plus mr-2"></i>
						新建角色
					</el-button>
				</span>
			</div>
			<div class="roleMain ml-16" v-loading="loading">
				<div class="top flex-row-align-center flex-just-start">
					<div class="top_title">
						<p class="ml-20 mt-10 font-h3-medium">{{ `${activeRoleObj.name}(${activeRoleObj.userRoleCount})` }}</p>
						<div class="ml-20 mt-12 mb-20 font-h5-regular flex-row-align-center flex-just-start yx-color-text-regular">
							<span>状态：</span>
							<template v-if="activeRoleObj.status === 0">
								<div class="status_icon success mr-8"></div>
								<span style="color: #3d3d3d">已启用</span>
							</template>
							<template v-else>
								<div class="status_icon info mr-8"></div>
								<span style="color: #3d3d3d">已禁用</span>
							</template>
							<span class="ml-24 mr-24">创建时间：{{ activeRoleObj.createTime }}</span>
							<span class="remark">备注：{{ activeRoleObj.remark | formatEmpty }}</span>
						</div>
					</div>
					<div class="top_edit" v-if="!isPresetsRoles">
						<span v-auth="['system:role:update']" @click="editRole" class="hover yx-color-text-regular font-h5-regular cursor-pointer">
							<i class="el-icon-edit"></i>
							<span>编辑</span>
						</span>
						<span v-if="$auth.hasPermiAnd(['system:role:update', 'system:role:delete'])" class="ml-8 mr-8" style="color: #eaebf0">|</span>
						<span v-auth="['system:role:delete']" @click="deletRole" class="hover yx-color-text-regular font-h5-regular cursor-pointer">
							<i class="el-icon-delete"></i>
							<span>删除</span>
						</span>
					</div>
				</div>
				<div class="ml-20 mt-4">
					<el-tabs v-model="activeName" @tab-click="handleClick">
						<el-tab-pane :label="item.name" v-for="item in roleTabs" :key="item.id" :tabIndex="item.id">
							<Tab
								ref="tabRef"
								:tabIndex="tabIndex"
								:roleObj="activeRoleObj"
								:isAdmin="isAdmin"
								:memberList="memberList"
								:total="total"
								:activeIndex="activeIndex"
								@refresh="() => getRoleList(2)"
								@getRoleMember="getRoleMember"
							>
							</Tab>
						</el-tab-pane>
					</el-tabs>
					<multi-table v-if="tabIndex == 0"
							:columns="filterColumns"
							:distanceTop="35"
							:subtractWidth="245"
							:total="total"
							:list="memberList"
							@gePartnerList="getPager"
							class="mr-20"
						></multi-table>
				</div>
			</div>
		</div>

		<el-dialog :title="title" :visible.sync="disTipDialog" width="426px" class="tipDialog">
			<i class="el-icon-warning mr-6 font-h2-regular" style="color: #ff7038"></i>
			<span class="ft-14" v-if="isDelRole">是否确认删除角色？</span>
			<template v-else>
				<span class="ft-14">是否确认删除该成员？</span>
				<p class="mt-12 ml-24">删除后，该成员将不再有【{{ activeRoleObj.name }}】角色的相关权限。</p>
			</template>
			<span slot="footer" class="dialog-footer">
				<el-button @click="disTipDialog = false">取 消</el-button>
				<el-button type="primary" @click="delet">删除</el-button>
			</span>
		</el-dialog>
		<AddRoleDraw ref="addRoleDraw" @refresh="getRoleList" :roleObj="activeRoleObj" :lastSortNumb="lastSortNumb"> </AddRoleDraw>
	</div>
</template>
<script>
import { getRoleList, getRoleMember, roleDelUser, deletRole } from '@/api/teamManage';
import Tab from './components/tab/tab.vue';
import { arrSortByProperty } from '@/utils/common';
import throttle from 'lodash/throttle';
import { tzRoleType } from '@/utils/dataMap';
import { columns, superColumns } from './components/tab/columns';
const { checkAuth } = HOC;
export default {
	components: {
		Tab,
		AddRoleDraw: () => import('./components/addRoleDraw/addRoleDraw.vue'),
	},
	data() {
		return {
			tabIndex: 0,
			activeName: 0,
			disTipDialog: false,
			roleList: [],
			memberList: [],
			optionColor: 'option',
			roleTabs: [
				{
					name: '角色成员',
					id: 0,
				},
				{
					name: '角色权限',
					id: 1,
				},
			],
			pageInfo: {
				pageNo: 1,
				pageSize: 10,
			},
			total: 0,
			selectUserId: '',
			deletType: '',
			loading: true,
			roleLoading: false,
			activeRoleObj: {},
			columns,
			superColumns
		};
	},
	computed: {
		// 当前角色类型是否是管理员
		isAdmin({ activeRoleObj }) {
			return activeRoleObj?.scopeType === tzRoleType.id;
		},
		isPresetsRoles({ activeRoleObj }) {
			let codeList = ['TENANT_ADMIN'];
			return codeList.includes(activeRoleObj?.code);
		},
		// 删除类型是否为删除角色
		isDelRole() {
			return this.deletType === 'role';
		},
		// 删除弹窗标题
		title() {
			return this.isDelRole ? '删除角色' : '删除成员';
		},
		// 角色列表中第一个角色
		firstSelect() {
			return this.roleList[0];
		},
		// 角色列表中最后一个角色
		lastSelect() {
			const _roleList = [...this.roleList];
			const [lastRole = {}] = _roleList.reverse();
			return lastRole;
		},
		// 角色列表中最后一个角色的排序号
		lastSortNumb() {
			return this.lastSelect?.sort;
		},
		// 当前角色的角色ID
		activeIndex() {
			return this.activeRoleObj?.id;
		},
		filterColumns() {
			return this.isAdmin ? this.superColumns : this.columns;
		},
	},
	methods: {
		/**
		 * 获取系统角色
		 * @param {*} e
		 */
		async getRoleList(e) {
			this.roleLoading = true;
			let data = await getRoleList();
			this.roleList = arrSortByProperty(JSON.parse(JSON.stringify(data)), 'sort', 'asc');
			this.roleLoading = false;
			if (e === 1) {
				this.activeRoleObj = this.lastSelect;
				this.activeTab(this.lastSelect); //添加新角色，默认选中新增加项
				return;
			} else if (e === 2) {
				// 选中当前选中项
				this.activeRoleObj = this.roleList.find(item => item.id === this.activeRoleObj.id);
				this.activeTab(this.activeRoleObj);
				return;
			}
			this.activeRoleObj = this.firstSelect;
			this.activeTab(this.firstSelect); //如果e为空，默认选中第一项/
		},
		/**
		 * 左边tab 点击
		 * @param {*} val
		 */
		activeTab(val) {
			this.$refs.tabRef[0]?.reset();
			if (!val) return;
			this.activeRoleObj = val;
			({
				0: this.getRoleMember,
				1: this.getRoleMenuPower,
			})[this.tabIndex]();
		},
		// 角色成员列表操作项
		getButtons() {
			const arr = [];
			arr.push({
				label: '删除',
				type: 'text',
				classtype: 3,
				isShow: this.$auth.hasPermi('system:permission:assign-user-role'),
				click: item => this.showDialog(item),
			});
			return arr.filter(item => item.isShow);
		},
		// 删除用户和新增用户是同一个接口，但是不同参数
		showDialog(val) {
			this.selectUserId = val.userId;
			this.deletType = 'members';
			this.disTipDialog = true;
		},
		// 获取角色成员列表
		getRoleMember: throttle(async function (val = {}) {
			this.loading = true;
			const { pageInfo } = this;
			val.pageNo && (this.pageInfo.pageNo = val.pageNo);
			val.pageSize && (this.pageInfo.pageSize = val.pageSize);
			const params = { ...pageInfo, ...val };
			const _pageInfo = {
				...params,
				roleId: this.activeIndex,
			};
			this.memberList = [];
			const data = await getRoleMember(_pageInfo);
			this.memberList = data.records.map(item => {
				return {
					...item,
					operations: this.getButtons(item),
				};
			});
			this.total = data.total;
			this.loading = false;
		}, 1000),
		// 添加角色-权限校验
		addRole: checkAuth(function () {
			this.$refs.addRoleDraw.show('add');
		}, 'system:role:create'),
		// 修改角色信息
		editRole: checkAuth(function () {
			this.$refs.addRoleDraw.show('edit');
		}, 'system:role:update'),
		// 删除角色
		deletRole() {
			this.deletType = 'role';
			this.disTipDialog = true;
		},

		//获取数据的权限
		getRoleMenuPower() {
			this.$nextTick(() => {
				this.$refs.tabRef[1].getRoleMenuPower();
			});
		},
		// 角色成员/角色权限tab切换
		handleClick(e) {
			this.$refs.tabRef[0]?.reset();
			this.tabIndex = e.index;
			this.getRoleMenuPower();
			this.activeName == 0 && this.getRoleList(2);
		},
		//删除角色或者成员需要进行deletType判断
		async delet() {
			const { activeIndex: roleId, selectUserId: userId } = this;
			this.isDelRole ? await deletRole({ id: roleId }) : await roleDelUser({ roleId, userId });
			this.getRoleList(this.isDelRole ? void 0 : 2);
			this.disTipDialog = false;
		},
		getPager(val) {
			this.pageInfo.pageNo = val.page_index;
			this.pageInfo.pageSize = val.page_size;
			this.getRoleMember(this.pageInfo)
		},
	},
	created() {
		this.getRoleList();
	},
};
</script>
<style lang="less" scoped>
.roleManage {
	height: 100%;
	background: @background-color-base;

	.roleManage-head {
		width: calc(100% - 42px);
		background: #ffffff;
		text-indent: 8px;
		font-size: 14px;
		font-weight: 400;
	}

	.rolePart {
		height: calc(100% - 100px);

		.roleAside {
			width: 228px;
			background-color: #ffffff;
			overflow: auto;
			border-radius: 2px;
			padding-bottom: 55px;
			color: #4e596a;

			&::-webkit-scrollbar {
				width: 6px;
			}

			&::-webkit-scrollbar-thumb {
				height: 26px;
				border-radius: 3px;
				background-color: @border-color-lighter;
			}

			.roleName {
				height: 36px;
				width: 214px;
				margin-top: 13px;
				margin-left: 7px;
				border-radius: 4px;

				&:hover {
					background: #edf4ff;
				}
			}

			.roleName + .roleName {
				margin-top: 8px;
			}
		}

		.roleMain {
			overflow: auto;
			width: calc(100% - 254px);
			border-radius: 2px;
			background-color: #ffffff;

			&::-webkit-scrollbar {
				width: 6px;
			}

			&::-webkit-scrollbar-thumb {
				height: 26px;
				border-radius: 3px;
				background-color: @border-color-lighter;
			}
		}
	}
}

.active {
	color: @color-primary;
	background-color: #edf4ff;
}

.top {
	height: 92px;
	border-bottom: 1px solid #eaebf0;
	position: relative;

	.top_title {
		width: 90%;
	}

	.top_edit {
		position: absolute;
		right: 24px;
	}
}

.status_icon {
	width: 6px;
	height: 6px;
	border-radius: 50%;
}

.success {
	background-color: @color-success;
}

.info {
	background-color: @color-info;
}

.remark {
	width: 20vw; // 宽度100%：1vw等于视口宽度的1%；1vh等于视口高度的1%
	white-space: nowrap; // 溢出不换行
	overflow: hidden; // 超出的文本隐藏
	text-overflow: ellipsis;
}

/deep/ .el-tabs__nav-wrap.is-top {
	margin-right: 20px !important;
}
</style>
